var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0.25H7.75C8.08152 0.25 8.39946 0.381696 8.63388 0.616116C8.8683 0.850537 9 1.16848 9 1.5V2.75H11.5C11.8315 2.75 12.1495 2.8817 12.3839 3.11612C12.6183 3.35054 12.75 3.66848 12.75 4V10.875C12.75 11.2065 12.6183 11.5245 12.3839 11.7589C12.1495 11.9933 11.8315 12.125 11.5 12.125H1.5C1.16848 12.125 0.850537 11.9933 0.616116 11.7589C0.381696 11.5245 0.25 11.2065 0.25 10.875V4C0.25 3.30625 0.80625 2.75 1.5 2.75H4V1.5C4 0.80625 4.55625 0.25 5.25 0.25ZM7.75 2.75V1.5H5.25V2.75H7.75Z",
    fill: "#063D8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusiness);
export default __webpack_public_path__ + "static/media/icon-business.e829928f251cfd9590574c920c4fabcb.svg";
export { ForwardRef as ReactComponent };